import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Query params that should persist across all navigations
const PERSISTENT_PARAMS = ['hidegemini'];

/**
 * Custom hook that wraps useNavigate to preserve specified query params across navigations
 */
const useNavigateWithParams = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateWithParams = useCallback((to, options) => {
    const currentParams = new URLSearchParams(location.search);

    // Build the target URL
    let targetPath = to;
    let targetSearch = '';

    if (typeof to === 'string') {
      const [path, search] = to.split('?');
      targetPath = path;
      targetSearch = search || '';
    } else if (typeof to === 'object' && to.pathname) {
      targetPath = to.pathname;
      targetSearch = to.search ? to.search.replace('?', '') : '';
    }

    // Parse target search params
    const targetParams = new URLSearchParams(targetSearch);

    // Preserve persistent params from current URL if not already in target
    PERSISTENT_PARAMS.forEach(param => {
      const value = currentParams.get(param);
      if (value && !targetParams.has(param)) {
        targetParams.set(param, value);
      }
    });

    // Build final URL
    const finalSearch = targetParams.toString();
    const finalUrl = finalSearch ? `${targetPath}?${finalSearch}` : targetPath;

    navigate(finalUrl, options);
  }, [navigate, location.search]);

  return navigateWithParams;
};

export default useNavigateWithParams;
